import { useCallback, DependencyList } from 'react'

import { checkDeps, useDeepCompareMemoize } from 'helpers/hooks'

/**
 * This is a drop-in replacement for React.useCallback when dependencies
 * contain non primitive values and a deep comparison is required.
 *
 * @see https://github.com/kentcdodds/use-deep-compare-effect
 * @see https://github.com/sandiiarov/use-deep-compare
 *
 * @param callback
 * @param dependencies
 */
function useDeepCompareCallback<T extends unknown[], U>(
    callback: (...args: T) => U,
    dependencies: DependencyList
): (...args: T) => U {
    if (process.env.NODE_ENV !== 'production') {
        checkDeps(dependencies)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useCallback(callback, useDeepCompareMemoize(dependencies))
}

export default useDeepCompareCallback
